import { useState, useEffect } from "react";
import CryptoJS from 'crypto-js';

const useToken = (url, request, setValue) => {
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const abortController = new AbortController();
        const signal = abortController.signal;
        const originUrl = window.location.origin;
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/text");
        myHeaders.append("trans_id", process.env.REACT_APP_TRANS_ID);

        const encryptedBase64Key = process.env.REACT_APP_POR_REDK;
        const parsedBase64Key = CryptoJS.enc.Base64.parse(encryptedBase64Key);

        const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(request), parsedBase64Key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
        });

        const doFetch = async () => {
            setLoading(true);
            try {
                const res = await fetch(url, {
                    signal,
                    method: 'POST',
                    headers: originUrl.includes('mobily.com.sa') ? myHeaders : {},
                    body: encryptedData
                });
                const data = await res.text();
                const decrypted = CryptoJS.AES.decrypt(data, parsedBase64Key, {
                    mode: CryptoJS.mode.ECB,
                    padding: CryptoJS.pad.Pkcs7
                });
                const response = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));

                if (!signal.aborted) {
                    setResponse(response?.ab);
                    setError(null);
                    setLoading(false);
                    setValue(true);
                }
            } catch (err) {
                if (!signal.aborted) {
                    setError(err.message);
                    setLoading(false);
                }
            } finally {
                setLoading(false);
            }
        };

        doFetch();
        return () => {
            abortController.abort();
        };
    }, [url]);

    return { response, error, loading };
};

export default useToken;